import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../basic';
import { routes } from '../../../../../utils/helpers/ApiClient';
import PhdSystemStateSettingsSection from './components/PhdSystemStateSettingsSection.jsx';
import PhdDocumentTemplatesSection from './components/PhdDocumentTemplatesSection.jsx';
import PhdDocumentVariablesSection from './components/PhdDocumentVariablesSection.jsx';
import PhdSchoolYearTransitionSection from './components/PhdSchoolYearTransitionSection.jsx';
import PhdPageContext from '../../../../common/Phd/PhdPageContext.jsx';

const PhdSettingsPage = () => {
  const { t } = useTranslation();
  const pageTitle = t('Nastavenia');
  const [prefillVariableKey, setPrefillVariableKey] = useState(null);

  useEffect(() => {
    document.title = `${pageTitle} - FRI CMS`;
  }, [pageTitle]);

  return (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        permissionsBasic="phd-system-states"
      />
      <div style={{ margin: '10px' }}>
        <PhdPageContext
          title={t('Čo môžete nastaviť?')}
          description={t(
            'Pripravte prechod školského roku, spravujte DOCX šablóny a premenné a nastavte otvorenie systému. Pred zmenou skontrolujte stav príslušnej sekcie.',
          )}
        />
        <PhdSchoolYearTransitionSection />
        <PhdDocumentTemplatesSection onCreateVariable={setPrefillVariableKey} />
        <PhdDocumentVariablesSection
          prefillKey={prefillVariableKey}
          onPrefillHandled={() => setPrefillVariableKey(null)}
        />
        <PhdSystemStateSettingsSection />
      </div>
    </>
  );
};

export default PhdSettingsPage;
